import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { basename } from 'path';
import configurator from 'bookingbug-configurator-js';
import deepmerge from 'deepmerge';
import { storeTranslations } from '../store/actions/i18n';

const Intl = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const { locale, translations } = useSelector(({ i18n }) => ({
    locale: i18n.locale,
    translations: i18n.translations,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    const files = require.context('../', true, /\.translations\.json$/);
    const translationsFiles = {};
    files.keys().forEach((file) => {
      const content = files(file);
      const name = basename(file, '.translations.json').toUpperCase();
      translationsFiles[name] = content;
    });

    const overrides = configurator.getTranslations(locale) || {};
    const mergedTranslations = deepmerge(translationsFiles, overrides);

    dispatch(storeTranslations({
      [locale]: mergedTranslations,
    }));

    setLoading(false);
  }, [dispatch, locale]);

  if (!translations || loading) return false;
  return (
    <IntlProvider locale={locale} defaultLocale={locale}>
      { children }
    </IntlProvider>
  );
};

export default Intl;
